module.exports = __webpack_public_path__ + "static/media/star-highlight.36b359ac.png";